import { render, staticRenderFns } from "./Curriculo_TrocaSenha.vue?vue&type=template&id=77f21da1&scoped=true"
import script from "./Curriculo_TrocaSenha.vue?vue&type=script&lang=js"
export * from "./Curriculo_TrocaSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f21da1",
  null
  
)

export default component.exports